export default __webpack_public_path__ + "static/media/dropdown_arrow_red_rotated.d45ed58b.svg";